import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AdddoctypepopupComponent } from '../generalpopup/adddoctypepopup/adddoctypepopup.component';

@Component({
  selector: 'app-empdocument',
  templateUrl: './empdocument.component.html',
  styleUrls: ['./empdocument.component.css']
})
export class EmpdocumentComponent implements OnInit {


  constructor(private toastr: ToastrService,private appService: AppdataService,
    public loginService:LoginserviceService,private activeModal: NgbActiveModal,private confirmationDialogService: ConfirmationDialogService,
    private productFindService: NgbModal,) { }

//Save Validation
submitted:boolean;
successfully:boolean;

empdocumentform=new FormGroup({
doctypeid:new FormControl(0,Validators.required),          
docnum:new FormControl('',Validators.required),   
issuedt:new FormControl(''),   
expirydt:new FormControl(''),   
descr:new FormControl(''),   
});

//Edit Get Values
doctypeColl:any=[];

@Input() empdocumentid:any=0;
@Input() doctypeid:any=null
@Input() docnum:any=null;
@Input() issuedt:any=null;
@Input() expirydt:any=null;
@Input() descr:any=null;

@Output() emitData = new EventEmitter();


ngOnInit() {

this.empdocumentform.reset();
this.fnInitializeFormGroup(); 
this.fngetDocType();
}


fnInitializeFormGroup(){
this.empdocumentform.setValue({
  doctypeid:this.doctypeid,    
  docnum:this.docnum,   
  issuedt:this.issuedt,   
  expirydt:this.expirydt,   
  descr:this.descr,    
})
}

//Get 
fngetDocType() {
  var data = {
  'doctypeid':0,
  'companyid':this.loginService.fnGetCompanyId()          
  }
  this.appService.getDocType(data)
  .subscribe(
  (res)=>{                
  if(res.json().status===200){  
  this.doctypeColl=res.json().result;     
  }
  else {
  this.loginService.fnAPIError(res.json())
  }

  },
  (err)=>{          
  this.toastr.error('Error', err);
  })
}

fnSaveBtnClick(){
try{
this.submitted=true;
this.successfully=false;
//Validate
if(this.empdocumentform.valid){


  
const index = this.doctypeColl.findIndex(sku => sku.doctypeid === this.empdocumentform.get('doctypeid').value); 

//Check
var data = {
  empdocumentid: this.empdocumentid,                      
  doctypeid:this.empdocumentform.get('doctypeid').value, 
  doctypename:this.doctypeColl[index].doctypename, 
  docnum:this.empdocumentform.get('docnum').value,     
  issuedt:this.empdocumentform.get('issuedt').value,   
  expirydt:this.empdocumentform.get('expirydt').value,   
  descr:this.empdocumentform.get('descr').value,                     
}
this.emitData.emit(data);  
this.activeModal.close(true);  

}

}catch(ex){
this.fnShowErrorMsg(ex);
}
}

public decline() {
this.activeModal.close(false);
}


private  fnShowErrorMsg(ex){
this.toastr.warning('Internal Error', ex);       
}



}
